import {flow, get, raise} from '@logistics-frontend/utils'

import {CardBoundContextResponse} from '../../../repo/cargo-corp/types'

export const toBindingUrl: (response: CardBoundContextResponse) => string = flow(
  get('context.binding_url'),
  function _toBindingUrl(url?: string): string {
    return url || raise('[toBindingUrl] empty binding_url')
  },
)
